import { FloatingFormItem } from '@/components/_common';
import { ManifestationRecipientInvoice } from '@/core/domain/invoice/recipientInvoice/recipientInvoice.types';
import {
  ManifestNotesFormValues,
  ManifestNotesType,
} from '@/core/domain/invoiceTransmissionHub/AuxiliaryDocuments/AuxiliaryDocuments.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Form, Input, Modal, ModalProps, Row, Select } from 'antd';
import { useEffect } from 'react';

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel: VoidFunction;
  onCallback: (values: ManifestNotesFormValues) => void;
  manifestationRecipientSelect?: ManifestationRecipientInvoice;
}

export default function RecipientInvoiceEditModal({
  onCancel,
  onCallback,
  manifestationRecipientSelect,
  ...props
}: Props) {
  const [form] = Form.useForm<ManifestNotesFormValues>();
  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  const manifestType = Form.useWatch('type', form);

  useEffect(() => {
    if (manifestationRecipientSelect) {
      form.setFieldsValue({
        reason: manifestationRecipientSelect.reason,
        type: manifestationRecipientSelect.manifestType,
      });
    }
  }, [props.open]);

  const manifestTypeOptions = [
    {
      value: ManifestNotesType.confirmedOperation,
      label: 'Confirmação da operação',
    },
    { value: ManifestNotesType.confirmed, label: 'Ciência da Emissão' },
    {
      value: ManifestNotesType.unknown,
      label: 'Desconhecimento da Operação',
    },
    {
      value: ManifestNotesType.notExecuted,
      label: 'Operação não Realizada',
    },
  ];

  function handleCancel() {
    form.resetFields();
    onCancel();
  }

  async function handleOk() {
    try {
      const values = await form.validateFields();

      onCallback(values);

      handleCancel();
    } catch {}
  }

  return (
    <Modal
      width={400}
      title="Edição de nota"
      onCancel={handleCancel}
      onOk={handleOk}
      {...props}
    >
      <Form form={form} style={{ marginBottom: '2em' }}>
        <Row gutter={[12, 5]}>
          <Col span={24}>
            <FloatingFormItem name="type" label="Tipo">
              <Select
                allowClear
                options={manifestTypeOptions.map((item) => ({
                  value: item.value,
                  label: item.label,
                }))}
              />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem
              name="reason"
              label="Motivo"
              rules={
                manifestType === ManifestNotesType.notExecuted
                  ? [
                      defaultEmptyFieldError,
                      { min: 15, message: 'Informe 15 ou mais caracteres' },
                    ]
                  : []
              }
            >
              <Input.TextArea rows={2} />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
